<template>
  <div>
    <div class="d-flex toolbar justify-content-between mb-4">
      <h4 class="text-color-4">เสี่ยงตีกลับ</h4>
    </div>
    <div class="mb-4"></div>

    <Card grey>
      <div slot="body">
        <label for="blacklist">ใส่หมายเลขโทรศัพท์ในบรรทัดใหม่</label>
        <textarea class="form-control mb-2"
                  id="blacklist"
                  v-model="blacklist"
                  rows="10"
                  :disabled="loading"
                  style="resize: vertical; overflow-y: auto;"></textarea>

        <div class="text-center">
          <Button variant="primary"
                  size="md"
                  @click="handleUpdate"
                  :loading="loading">
            อัปเดต
          </Button>
        </div>
      </div>

    </Card>
  </div>
</template>

<script>
import Card from "@/components/core/Card";
import Toggle from "@/components/core/Toggle";
import Spinner from "@/components/core/Spinner";
import Button from "@/components/core/Button";
import { http } from "@/helpers/http";
import APP_URL from "../../../helpers/urls";

export default {
  name: "SellerSettingsApi",

  components: {
    Card,
    Toggle,
    Spinner,
    Button
  },

  data() {
    return {
      loading: false,
      blacklist: null,
    };
  },

  created() {
    this.fetchBlackList();
  },

  mounted() { },

  methods: {

    async fetchBlackList() {
      this.loading = true;
      try {
        const { data } = await http.get(APP_URL("utils") + "/blacklist");
        this.blacklist = data.blacklist;
      } catch (error) {
        console.error("Error fetching blacklist:", error);
      } finally {
        this.loading = false;
      }
    },

    async handleUpdate() {
      this.loading = true;
      try {
        await http.post(APP_URL("utils") + "/blacklist", {
          blacklist: this.blacklist || ""
        });
      } catch (error) {
        console.error("Error updating blacklist:", error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>